// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { SettingsSectionOut } from './settingsSectionOut.zod.ts';

export const SettingsOut = zod.object({
  "sections": zod.array(SettingsSectionOut)
});

export type SettingsOut = zod.input<typeof SettingsOut>;
export type SettingsOutOutput = zod.output<typeof SettingsOut>;
